// More exported functions may be added to this file
/* eslint-disable import/prefer-default-export */

export const sanitizePhoneString = (input: string): string =>
  input.replace(/\D/g, '');
